import BaseType from "./BaseType";

export default class Topfband extends BaseType(THREE.Mesh) {

    constructor(vsData) {
        super(vsData);
        const dicke = this.vsData.schrank.options.getFloat('tuer_topfband_dicke');
        const durchmesser = this.vsData.schrank.options.getFloat('tuer_topfband_durchmesser');
        this.geometry = new THREE.CylinderGeometry(durchmesser / 2, durchmesser / 2, dicke, 20);
        this.material = new THREE.MeshStandardMaterial({
            color: new THREE.Color(this.vsData.schrank.options.getInt('tuer_topfband_farbe')),
            /* shininess: APP.settings.getFloat('tuer_topfband_shininess') */
            roughness: 0.1
        });
        this.name = "Topfband";
    }

    vsUpdate() {
        this.position.copy(this.vsData.position);
        this.quaternion.copy(this.vsData.quaternion);
    }
}
